export const NotesDryingRatingAttributeNames = [
  "anomalies",
  "general",
  "roomConditions",
  "roomTemperature",
  "EDTGeneral",
  "EDTPhase4",
  "EDTPauses"
] as const;

export type NotesDryingRatingAttribute = typeof NotesDryingRatingAttributeNames[number];
export type NotesDryingRating = {
  [Attribute in NotesDryingRatingAttribute]: number[];
};
